module.exports = __webpack_public_path__ + "media/images/externalLinkGray-fba77e488cf912a28fd321f3e63059b2.svg";